import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'
import Api from 'fou-api'

export default {
  namespaced: true,

  state () {
    return {
      accounts: [],
      isSuccess: false
    }
  },

  getters: {
    allAccounts: state => {
      return state.accounts
    },
    isSuccessFull: state => {
      return state.isSuccess
    }
  },

  mutations: {
    setAccounts (state, accounts = []) {
      state.accounts = [...state.accounts, ...accounts]
    },
    resetAccounts (state) {
      state.accounts = []
    },
    setIsSuccess (state) {
      state.isSuccess = true
    },
    unsetIsSuccess (state) {
      state.isSuccess = false
    }
  },

  actions: {
    getAllAccounts ({ commit, state }, options = {}) {
      return new Promise((resolve, reject) => {
        Api.Accounts.getAccounts(
          options.userId
        )
          .then((response) => {
            const { data } = response
            commit('setAccounts', data.accounts)
            return resolve(data.accounts)
          })
          .catch((error) => {
            const err = Errors.create(error)
            commit('errors/add', err)
            return reject(err)
          })
      })
    },
    transferAccountDetail ({commit, state}, options = {}) {
      return new Promise((resolve, reject) => {
        Api.Accounts.transferAccountDetails(
          options
        )
          .then((response) => {
            let {data} = response
            commit('setIsSuccess')
            return resolve(data)
          })
          .catch((error) => {
            commit('setIsSuccess')
            let err = Errors.create(error)
            // commit('errors/add', err)
            return reject(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
